/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBoxDashAlt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M12.766 20H13v.375l.53.848-1 .625a1.002 1.002 0 0 1-1.06 0l-1-.625.53-.848V20h.234l.296-.472.47.293.47-.293zM9.53 18.278l-1.06 1.695-2-1.25 1.06-1.695zm8 .445-2 1.25-1.06-1.695 2-1.25zM13 18h-2v-2h2zm-8-2.554.53.332-1.06 1.695-1-.625A1 1 0 0 1 3 16v-1h2zM21 16a1 1 0 0 1-.47.848l-1 .625-1.06-1.695.53-.332V15h2zm-7.47-2.777-.53.331V14h-2v-.446l-.53-.33 1.06-1.696.47.293.47-.293zM5 13H3v-2h2zm16 0h-2v-2h2zM9.53 10.278l-1.06 1.695-2-1.25 1.06-1.695zm8 .445-2 1.25-1.06-1.695 2-1.25zM5 7.375l.072.117.458.286L5.39 8l.14.223-.458.285L5 8.625V9h-.234l-.296.473L3.714 9H3V8a1 1 0 0 1 .47-.847l1-.625zm15.53-.222A1 1 0 0 1 21 8v1h-.714l-.756.473L19.234 9H19v-.375l-.073-.117-.457-.285.138-.223-.138-.222.457-.286.073-.117.53-.847zm-11-1.43-2 1.25-1.06-1.695 2-1.25zm8-.445-1.06 1.695-2-1.25 1.06-1.695zm-5.934-3.192a1 1 0 0 1 .934.067l1 .625-1.06 1.695L12 4.18l-.47.294-1.06-1.695 1-.625z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgBoxDashAlt as BoxDashAlt };
